import type { HeadlineResponse } from '@on3/api';
import { On3IconLockPremium } from '@on3/icons';
import { Link } from '@on3/ui-lib/components/Link';

import styles from './ArticleCondensed.module.scss';

export const ArticleCondensed = ({
  title,
  isPremium,
  fullUrl,
}: HeadlineResponse) => {
  return (
    <Link className={styles.block} href={fullUrl}>
      <article>
        <h3 className={styles.title}>{title}</h3>
        {isPremium && <On3IconLockPremium className={styles.lock} />}
      </article>
    </Link>
  );
};
